import { lazy } from "react";
import Loadable from "components/Loadable.tsx";

const MemberList = Loadable(
  lazy(() => import("features/member/components/List"))
);
const MemberPage = Loadable(
  lazy(() => import("features/member/components/Page"))
);
const MemberView = Loadable(
  lazy(() => import("features/member/components/DetailView/Profile"))
);
const UploadMembers = Loadable(
  lazy(() => import("features/member/components/UploadMemebrs"))
);
const IncompleteRegistrationList = Loadable(
  lazy(() => import("features/member/components/IncompleteRegistrationList"))
);

const routes = {
  path: "member",
  children: [
    { path: "", element: <MemberList /> },
    { path: "add", element: <MemberPage /> },
    { path: "uploadMemebrs", element: <UploadMembers /> },
    { path: "edit/:memberID?", element: <MemberPage /> },
    { path: "view/:memberID?", element: <MemberView /> },
    { path: "incomplete", element: <IncompleteRegistrationList /> },
  ],
};

export default routes;
